/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventalreadypaidouterror4Inputs */

const en_eventalreadypaidouterror4 = /** @type {(inputs: Eventalreadypaidouterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This event was already paid out, so it can no longer be cancelled.`)
};

const de_eventalreadypaidouterror4 = /** @type {(inputs: Eventalreadypaidouterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Event wurde schon ausgezahlt, es lässt sich nicht mehr absagen.`)
};

/**
* | output |
* | --- |
* | "This event was already paid out, so it can no longer be cancelled." |
*
* @param {Eventalreadypaidouterror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventalreadypaidouterror4 = /** @type {((inputs?: Eventalreadypaidouterror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventalreadypaidouterror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventalreadypaidouterror4(inputs)
	return de_eventalreadypaidouterror4(inputs)
});
export { eventalreadypaidouterror4 as "eventAlreadyPaidOutError" }